import {
  Button,
  Col,
  Input,
  InputRef,
  Popover,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  TableColumnType,
  Tag,
  Tooltip,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";

import { ColumnsType } from "antd/es/table";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import { FilterDropdownProps } from "antd/es/table/interface";

import AddCurrenct from "./AddCurrency";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import { useClient } from "../../../Context/ClientContext";
import { useTheme } from "../../../Context/ThemeContext";
import {
  TextSearchTableEnum,
  TextSearchTableOption,
} from "../../../Common/SearchTableOptions";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import CurrencyServices from "../../../Services/CurrencyServices";
import InvoiceExportService from "../../../Services/InvoiceExportDetails";
import { tablePageSizeOptions } from "../../../Common/ThemeSetting";

interface ICurrencyDataType {
  countrySymbol: any;
  key: string;
  sno: number;
  companyId: string;
  id: number;
  countryName: string;
  countryId: string;
  currencyName: string;
  currencySymbol: string;
  system: boolean;
}

const CurrencyTable = () => {
  const { currentClient } = useClient();
  const { themeData } = useTheme();
  const { openNotification } = useContext(notificationContext);
  const searchInput = useRef<InputRef>(null);
  const [openDropdown, setOpenDropdown] = useState<DataIndex | null>(null);
  type DataIndex = keyof ICurrencyDataType;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [currencyList, setCurrencyList] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [searchUnit, setSearchUnit] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [openModel, setOpenModel] = useState<boolean>(false);
  const [currencyData, setCurrencyData] = useState<any>({});
  const [trigger, setTrigger] = useState<boolean>(false);
  const [exportType, setExportType] = useState<number>(-1);
  const [exportCurrencyData, setExportCurrencyData] = useState<any[]>([]);
  const [filter, setfilter] = useState<any>({
    sortCol: "",
    sortDir: "",
  });
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [searchColumns, setSearchColumns] = useState<any>({
    countryName: "",
    currencySymbol: "",
    currencyName: "",
  });
  const [searchColumnsDropDown, setSearchColumnsDropDown] = useState<{
    countryNameDropEnum: TextSearchTableEnum;
    countryNameDropPre: TextSearchTableEnum;
    currencyNameDropEnum: TextSearchTableEnum;
    currencyNameDropPre: TextSearchTableEnum;
    currencySymbolDropEnum: TextSearchTableEnum;
    currencySymbolDropPre: TextSearchTableEnum;
  }>({
    countryNameDropEnum: TextSearchTableEnum.contains,
    countryNameDropPre: TextSearchTableEnum.contains,
    currencyNameDropEnum: TextSearchTableEnum.contains,
    currencyNameDropPre: TextSearchTableEnum.contains,
    currencySymbolDropEnum: TextSearchTableEnum.contains,
    currencySymbolDropPre: TextSearchTableEnum.contains,
  });
  const [searchColumnCount, setSearchColumnCount] = useState<number>(0);

  useEffect(() => {
    if (currentClient?.id && (exportType === -1 || exportType)) {
      const requestModel = {
        countryName: searchColumns.countryName?.trim(),
        countryNameDropEnum: searchColumnsDropDown.countryNameDropEnum,
        currencySymbol: searchColumns.currencySymbol?.trim(),
        currencySymbolDropEnum: searchColumnsDropDown.currencySymbolDropEnum,
        currencyName: searchColumns.currencyName?.trim(),
        currencyNameDropEnum: searchColumnsDropDown.currencyNameDropEnum,
      };
      getCurrencyList(
        currentClient?.id,
        exportType >= 1 ? 0 : (page - 1) * pageSize,
        exportType >= 1 ? 0 : pageSize,
        filter.sortCol,
        filter.sortDir,
        searchUnit,
        searchColumnCount,
        requestModel
      );
    } else if (currentClient?.id === null) {
      console.error("currentClient is null Items");
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    trigger,
    page,
    pageSize,
    searchUnit,
    // location.pathname,
    filter.sortCol,
    filter.sortDir,
    exportType,
    searchColumns,
  ]);

  // --------- Get Units TableData API ---------
  const getCurrencyList = async (
    clientId: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    searchColumnCount?: number,
    requestModel?: any
  ) => {
    if (exportType < 1) {
      setLoading(true);
    }
    await CurrencyServices.getCurrencyList(
      clientId,
      start,
      length,
      sortCol,
      sortDir,
      search,
      searchColumnCount,
      requestModel
    )
      .then((res: any) => {
        if (res.result?.items?.length > 0) {
          console.log(res.result.items);
          let data = res.result.items?.map((v: any, i: any) => {
            return {
              // countryName: {
              //   id: v?.country?.id,
              //   name: v?.country?.name,
              // },
              countryName: v?.country?.name,
              countryId: v?.country?.id,
              companyId: v?.companyId,
              currencySymbol: v?.currencySymbol,
              currencyName: v?.currencyName,
              sno: v?.sno,
              id: v?.id,
              system: v?.system,
            };
          });

          if (exportType >= 1) {
            setExportCurrencyData(data);
            if (exportType === 1) {
              exportCsv(data);
            } else if (exportType === 2) {
              exportPDF(data);
            } else if (exportType === 3) {
              exportExcel(data);
            }
          } else {
            setCurrencyList(data);
            setLoading(false);
            // setTotalRecords(res.result?.totalRecords);
          }
          setTotalRecords(res.result?.totalRecords);
        } else if (res.result?.items?.length === 0) {
          setCurrencyList([]);
          setTotalRecords(res.result.totalRecords);
        }
        setLoading(false);
      })
      .catch((ex: any) => {
        console.error(ex.message);
        setLoading(false);
        setCurrencyList([]);
      });
  };

  const deleteCurrency = async () => {
    let res = await CurrencyServices.deleteCurrency(
      currentClient?.id,
      currencyData?.id
    );
    if (res?.status) {
      console.log("data", res);
      setConfirmation(false);
      setTrigger((x) => !x);
      openNotification("success", "Unit deleted successfully");
    } else {
      setConfirmation(false);
      openNotification("error", res.message);
    }
  };

  // Table Search Inide
  // const handleSearch = (
  //   selectedKeys: string[] | any,
  //   confirm: any,
  //   dataIndex: DataIndex
  // ) => {
  //   console.log("handleSearch", dataIndex, selectedKeys, searchColumns);
  //   switch (dataIndex) {
  //     case "countryName":
  //       if (selectedKeys[0] || searchColumns.countryName) {
  //         setSearchColumns({
  //           ...searchColumns,
  //           countryName: selectedKeys[0],
  //         });
  //       }
  //       break;
  //     case "currencySymbol":
  //       if (selectedKeys || searchColumns.currencySymbol) {
  //         setSearchColumns({
  //           ...searchColumns,
  //           currencySymbol: selectedKeys[0],
  //         });
  //       }
  //       break;
  //     case "currencyName":
  //       if (selectedKeys[0] || searchColumns.currencyName) {
  //         setSearchColumns({ ...searchColumns, currencyName: selectedKeys[0] });
  //       }
  //       break;
  //   }
  //   confirm();
  //   setOpenDropdown(null); // Close the dropdown
  // };

  const checkFilterType = (dataIndex: DataIndex) => {
    let isFilterTypeUnchanged = false;

    switch (dataIndex) {
      case "countryName":
        isFilterTypeUnchanged =
          searchColumnsDropDown.countryNameDropEnum ===
          searchColumnsDropDown.countryNameDropPre;
        break;
      case "currencyName":
        isFilterTypeUnchanged =
          searchColumnsDropDown.currencyNameDropEnum ===
          searchColumnsDropDown.currencyNameDropPre;
        break;
      case "currencySymbol":
        isFilterTypeUnchanged =
          searchColumnsDropDown.currencySymbolDropEnum ===
          searchColumnsDropDown.currencySymbolDropPre;
        break;
    }
    return isFilterTypeUnchanged;
  };

  const handleSearch = (
    selectedKeys: string[] | any,
    confirm: any,
    dataIndex: DataIndex
  ) => {
    const prevValue = searchColumns[dataIndex];
    const newValue =
      selectedKeys && selectedKeys[0] ? String(selectedKeys[0]).trim() : "";

    if (newValue === "" && (!prevValue || String(prevValue).trim() === "")) {
      confirm();
      setOpenDropdown(null);
      return;
    }

    if (
      typeof prevValue === "string" &&
      newValue === String(prevValue).trim() &&
      checkFilterType(dataIndex)
    ) {
      confirm();
      setOpenDropdown(null);
      return;
    }

    setSearchColumnsDropDown((prevState) => {
      const newState = { ...prevState };
      switch (dataIndex) {
        case "countryName":
          newState.countryNameDropPre = prevState.countryNameDropEnum;
          break;
        case "currencySymbol":
          newState.currencySymbolDropPre = prevState.currencySymbolDropEnum;
          break;
        case "currencyName":
          newState.currencyNameDropPre = prevState.currencyNameDropEnum;
          break;
      }
      return newState;
    });

    const wasEmpty = !prevValue || String(prevValue).trim() === "";
    const isNowPopulated = newValue !== "";

    if (wasEmpty && isNowPopulated) {
      setSearchColumnCount((prev) => prev + 1);
    } else if (!wasEmpty && !isNowPopulated) {
      setSearchColumnCount((prev) => prev - 1);
    }

    const newSearchColumns = { ...searchColumns };
    newSearchColumns[dataIndex] = newValue;
    setSearchColumns(newSearchColumns);

    confirm();
    setOpenDropdown(null);
  };

  const handleDropdownText = (
    dataIndex: DataIndex,
    valDropDown: TextSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "countryName":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          countryNameDropEnum: valDropDown,
          countryNameDropPre: searchColumnsDropDown.countryNameDropEnum,
        });
        break;
      case "currencyName":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          currencyNameDropEnum: valDropDown,
          currencyNameDropPre: searchColumnsDropDown.currencyNameDropEnum,
        });
        break;
      case "currencySymbol":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          currencySymbolDropEnum: valDropDown,
          currencySymbolDropPre: searchColumnsDropDown.currencySymbolDropEnum,
        });
        break;
    }
  };

  // const handleReset = (
  //   clearFilters: () => void,
  //   confirm: FilterDropdownProps["confirm"],
  //   dataIndex: DataIndex
  // ) => {
  //   clearFilters();
  //   confirm();
  //   // console.log("dataIndex", dataIndex, searchColumns);

  //   switch (dataIndex) {
  //     case "countryName":
  //       if (searchColumns.countryName) {
  //         setSearchColumns({
  //           ...searchColumns,
  //           countryName: "",
  //         });
  //       }
  //       break;
  //     case "currencyName":
  //       if (searchColumns.currencyName) {
  //         setSearchColumns({ ...searchColumns, currencyName: "" });
  //       }
  //       break;
  //     case "currencySymbol":
  //       if (searchColumns.currencySymbol) {
  //         setSearchColumns({ ...searchColumns, currencySymbol: "" });
  //       }
  //       break;
  //   }
  // };

  const handleReset = (
    clearFilters: () => void,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    clearFilters();
    confirm();

    let prevValue = searchColumns[dataIndex]; // check this input value present or notPresent

    if (prevValue) {
      setSearchColumnCount((prev) => prev - 1);
    }
    if (prevValue) {
      setSearchColumns((prev: any) => {
        const newSearchColumns = { ...prev };
        delete newSearchColumns[dataIndex];
        return newSearchColumns;
      });
    }
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    searchPlaceHolder?: string
  ): TableColumnType<ICurrencyDataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <>
          <Select
            defaultValue={TextSearchTableEnum.contains}
            style={{
              width: "100%",
              maxWidth: "200px",
              marginBottom: "8px",
            }}
            onChange={(val: TextSearchTableEnum) => {
              setExportCurrencyData([]);
              handleDropdownText(dataIndex, val);
              // setTextTypeSearchColumn(val);
              // setType(1);
            }}
            options={TextSearchTableOption?.map((x: any) => ({
              value: x.value,
              label: x.label,
            }))}
          />

          <Input
            ref={searchInput}
            placeholder={`Search.. ${searchPlaceHolder}`}
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
            }}
            onPressEnter={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            style={{ marginBottom: 8, display: "block", width: "200px" }}
          />
        </>

        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            // icon={<SearchOutlined />}
            size="small"
            style={{ width: 95 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 95 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    filterDropdownOpen: openDropdown === dataIndex,
    filterDropdownProps: {
      placement: "bottomLeft",
      // onOpenChange(open) {
      //   if (open) {
      //     setTimeout(() => searchInput.current?.select(), 100);
      //   }
      // },
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setOpenDropdown(dataIndex);
        setTimeout(() => {
          searchInput.current?.select();
        }, 100);
      } else {
        setOpenDropdown(null);
      }
    },
  });

  // --------- Corrency Table Columns  ---------
  const Columns: ColumnsType<ICurrencyDataType> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      width: "5%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    {
      title: "Country Name",
      dataIndex: "countryName",
      key: "Country.Name",
      sorter: true,
      width: "25%",
      filteredValue: searchColumns.countryName
        ? [searchColumns.countryName]
        : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record.system ? (
            <>
              {record?.countryName}
              {"  "}
              <Tag
                color="green"
                style={{
                  textAlign: "center",
                  width: 100,
                }}
              >
                Default Country
              </Tag>
            </>
          ) : (
            record?.countryName
          )}
        </Skeleton>
      ),
      // ...getColumnSearchProps("countryName", "Country Name"),
    },

    {
      title: "Currency Symbol",
      dataIndex: "currencySymbol",
      key: "CS",
      width: "15%",
      sorter: true,
      filteredValue: searchColumns.currencySymbol
        ? [searchColumns.currencySymbol]
        : null,
      render: (_, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.currencySymbol}
        </Skeleton>
      ),
      // ...getColumnSearchProps("currencySymbol", "Currency Symbol"),
    },
    {
      title: "Currency Name",
      dataIndex: "currencyName",
      key: "CN",
      width: "25%",
      sorter: true,
      filteredValue: searchColumns.currencyName
        ? [searchColumns.currencyName]
        : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.currencyName}
        </Skeleton>
      ),
      // ...getColumnSearchProps("currencyName", "Currency Name"),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "edit",
      width: "15%",
      render: (record: ICurrencyDataType) =>
        record?.system === false ? (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            <Row gutter={18}>
              <Col>
                <Tooltip title="Edit" placement="top" color="#3D4998">
                  <EditOutlined
                    // className="ca-edit-btn"
                    style={{
                      color: "#444653",

                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenModel(true);
                      setCurrencyData({
                        id: record?.id,
                        companyId: record?.companyId,
                        country: {
                          label: record?.countryName,
                          value: record?.countryId,
                        },
                        currencyName: record?.currencyName,
                        currencySymbol: record?.currencySymbol,
                      });
                    }}
                  />
                </Tooltip>
              </Col>
              <Col>
                <Tooltip title="Delete" placement="top" color="red">
                  <DeleteOutlined
                    // className="ca-edit-btn"
                    onClick={() => {
                      setCurrencyData({
                        id: record.id,
                        name: record.currencyName,
                      });
                      setConfirmation(true);
                    }}
                    style={{
                      color: "red",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              </Col>
            </Row>
          </Skeleton>
        ) : (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            <Row gutter={18}>
              <Col>
                <Tooltip title="Not Editable" placement="top" color="#3D4998">
                  <EditOutlined
                    style={{ color: "rgb(216 207 207)", cursor: "pointer" }}
                  />
                </Tooltip>
              </Col>
              <Col>
                <Tooltip
                  title="Default Currency are not delete"
                  placement="top"
                  color="#3D4998"
                >
                  <DeleteOutlined
                    style={{ color: "rgb(216 207 207)", cursor: "pointer" }}
                  />
                </Tooltip>
              </Col>
            </Row>
          </Skeleton>
        ),
    },
  ];

  //----- Table Ascending & Desending Order -----
  const tableSort = (pagination?: any, sort?: any, filter?: any) => {
    setfilter({
      sortCol: filter.column !== undefined ? filter.columnKey : "number",
      sortDir:
        filter.column !== undefined
          ? filter.order === "descend"
            ? "desc"
            : "asc"
          : "desc",
    });
    // console.log("sort1111111111111", sort?.TaxRate?.Rate, sort);
  };

  let path = "Currency List";
  const columnsA = [
    "S.No.",
    "Country Name",
    "Currency Symbol",
    "Currency Name",
  ];

  const fieldMapping = {
    "S.No.": (item: any) => item?.sno,
    "Country Name": (item: any) => item?.countryName,
    "Currency Symbol": (item: any) =>
      item?.currencySymbol === "1" ? "₹" : item?.currencySymbol,
    "Currency Name": (item: any) => item?.currencyName,
  };

  const generateFooterRow = (columns: string[]) => {
    return columns.map((col) => {});
  };

  const exportCsv = (exportData: any[]) => {
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      "",
      path,
      currentClient?.businessName
    );
    setExportType(0);
  };

  const exportPDF = (exportData: any[]) => {
    // InvoiceExportService.generatePDF(
    //   exportData,
    //   currentClient?.businessName,
    //   columnsA,
    //   fieldMapping,
    //   generateFooterRow,
    //   "",
    //   path
    // );
    InvoiceExportService.AutoDownloadPDF(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const exportExcel = async (exportData: any[]) => {
    await InvoiceExportService.generateExcel(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportCurrencyData.length > 0) {
              exportCsv(exportCurrencyData);
            } else {
              setExportType(1);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            if (exportCurrencyData.length > 0) {
              exportPDF(exportCurrencyData);
            } else {
              setExportType(2);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            if (exportCurrencyData.length > 0) {
              exportExcel(exportCurrencyData);
            } else {
              setExportType(3);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  return (
    <div>
      <Row justify="space-between">
        <Col>
          <Row gutter={15}>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setCurrencyData({});
                  setOpenModel(true);
                }}
              >
                Currency
              </Button>
            </Col>
            <Col>
              {currencyList.length === 0 ? (
                <Button icon={<DownloadOutlined />} disabled type="primary">
                  Export
                </Button>
              ) : (
                <Popover content={content} placement="rightTop" trigger="hover">
                  <Button
                    type="default"
                    icon={<DownloadOutlined />}
                    // onClick={() => exportCsv()}
                  >
                    Export
                  </Button>
                </Popover>
              )}
            </Col>
          </Row>
        </Col>
        <Col>
          <Input
            allowClear
            style={{ width: "220px" }}
            placeholder="Search here..."
            onChange={(e: any) => {
              setLoading(true);
              if (!e.cancelable) {
                //console.log("typeing user............");
                const searchUnit = setTimeout(() => {
                  setPage(1);
                  setSearchUnit(e.target.value);
                }, 1000);
                setExportCurrencyData([]);
                setExportType(-1);
                return () => clearTimeout(searchUnit);
              } else {
                // console.log("Click cancle............");
                setSearchUnit(e.target.value);
              }
            }}
            suffix={loading || searchUnit ? "" : <SearchOutlined />}
          />
        </Col>
      </Row>
      <Table
        className={`Tabel-style table-${themeData?.componentSize ?? "middle"}`}
        // loading={tableLoading}
        columns={Columns}
        locale={{
          triggerDesc: "",
          triggerAsc: "",
          cancelSort: "",
        }}
        dataSource={
          loading
            ? (Array.from({ length: pageSize }, (_, index) => ({
                key: `loading-${index}`,
              })) as ICurrencyDataType[])
            : currencyList
        }
        pagination={{
          total: totalRecords,
          current: page,
          pageSize: pageSize,
          showSizeChanger: true,
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
          },
          pageSizeOptions: tablePageSizeOptions,
          showTotal: (totalRecords, page) =>
            `${page[0]}-${page[1]} of ${totalRecords} items`,
        }}
        onChange={tableSort}
        // scroll={
        //   pageSize > 15 ? { x: 1000, y: window.innerHeight - 200 } : { x: 1000 }
        // }
        // scroll={
        //   data?.result?.items?.length > 0
        //     ? { x: undefined, y: window.innerHeight - 420 }
        //     : { x: undefined }
        // }
        // scroll={
        //   pageSize > 15 ? { x: 500, y: window.innerHeight - 320 } : { x: 500 }
        // }
      />
      {openModel && (
        <AddCurrenct
          open={true}
          data={currencyData}
          onCancel={() => setOpenModel(false)}
          setTrigger={setTrigger}
        />
      )}
      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => {
            setConfirmation(false);
          }}
          onYes={deleteCurrency}
          text={`Are you sure you want to delete this ${
            currencyData?.name ? ` "${currencyData?.name}"` : ""
          } Currency ? `}
        />
      )}
    </div>
  );
};

export default CurrencyTable;
